module.exports = __webpack_public_path__ + "img/reload.6d9ce2eb.svg";